(() => {
  const STORAGE_KEY = 'marston-theme-mode';
  const root = document.documentElement;
  const metaTheme = document.querySelector('meta[name="theme-color"]');

  /* Carga el refinamiento móvil del cupón desde el mismo CDN del tema.
     Antes el archivo existía, pero no estaba enlazado al storefront. */
  const activeThemeScript = document.currentScript;
  if (
    activeThemeScript &&
    activeThemeScript.src &&
    !document.querySelector('link[href*="marston-coupon-mobile.css"]')
  ) {
    const couponStylesheetUrl = activeThemeScript.src.replace(
      /marston-theme-mode\.js(?=([?#]|$))/,
      'marston-coupon-mobile.css'
    );
    if (couponStylesheetUrl !== activeThemeScript.src) {
      const couponStylesheet = document.createElement('link');
      couponStylesheet.rel = 'stylesheet';
      couponStylesheet.href = couponStylesheetUrl;
      couponStylesheet.setAttribute('data-marston-coupon-mobile', '');
      document.head.appendChild(couponStylesheet);
    }
  }

  function normalize(value) {
    return value === 'dark' ? 'dark' : 'light';
  }

  function currentMode() {
    return normalize(root.getAttribute('data-marston-theme'));
  }

  function setButtonState(mode) {
    document.querySelectorAll('[data-marston-theme-toggle]').forEach((button) => {
      const isDark = mode === 'dark';
      const targetLabel = isDark ? 'Modo claro' : 'Modo oscuro';
      const actionLabel = isDark ? 'Activar modo claro' : 'Activar modo oscuro';

      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', actionLabel);
      button.setAttribute('title', actionLabel);
      button.dataset.marstonTargetTheme = isDark ? 'light' : 'dark';

      const text = button.querySelector('.marston-theme-toggle__text');
      if (text) text.textContent = targetLabel;

      const label = button.querySelector('.marston-theme-toggle__label');
      if (label) label.textContent = actionLabel;
    });
  }

  function setMetaTheme(mode) {
    if (!metaTheme) return;
    metaTheme.setAttribute('content', mode === 'dark' ? '#1b0029' : '#ffffff');
  }

  function applyMode(mode, persist = false, animate = false) {
    mode = normalize(mode);

    if (animate && document.body) {
      document.body.classList.add('marston-theme-is-switching');
      window.setTimeout(() => document.body.classList.remove('marston-theme-is-switching'), 280);
    }

    root.setAttribute('data-marston-theme', mode);
    setButtonState(mode);
    setMetaTheme(mode);

    if (persist) {
      try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    }

    document.dispatchEvent(new CustomEvent('marston:themechange', { detail: { mode } }));
  }

  function bindButtons() {
    document.querySelectorAll('[data-marston-theme-toggle]').forEach((button) => {
      if (button.dataset.marstonThemeBound === 'true') return;
      button.dataset.marstonThemeBound = 'true';

      button.addEventListener('click', () => {
        const next = currentMode() === 'dark' ? 'light' : 'dark';
        applyMode(next, true, true);
      });
    });
  }

  function replaceProductHoodieSizeDiagram(mount) {
    if (!mount) return;

    const guide = mount.querySelector('[data-ms-guide-kind="poleron"]');
    if (!guide) return;

    const diagram = guide.querySelector('.ms-size-guide-diagram');
    if (!diagram || diagram.dataset.msHoodieArtReady === 'true') return;

    const oldSvg = diagram.querySelector('svg');
    if (oldSvg) {
      const image = document.createElement('img');
      image.className = 'ms-size-guide-product-hoodie-art';
      image.src = 'https://cdn.shopify.com/s/files/1/0559/3972/7523/files/marston-guia-medidas-poleron.png?v=1789316828';
      image.alt = 'Cómo medir ancho y largo de un polerón';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 700;
      image.height = 700;
      image.style.display = 'block';
      image.style.width = '100%';
      image.style.maxWidth = '300px';
      image.style.height = 'auto';
      image.style.margin = '0 auto';
      image.style.objectFit = 'contain';
      oldSvg.replaceWith(image);
    }

    const caption = diagram.querySelector('.ms-size-guide-diagram-caption');
    if (caption) {
      caption.textContent = 'El ancho y el largo se miden de la misma forma en ambos modelos.';
    }

    diagram.dataset.msHoodieArtReady = 'true';
  }

  function initNativeSizeGuide() {
    const source = document.querySelector('[data-ms-size-guide-source]');
    const wrapper = document.querySelector('#ms-info-tabs-wrapper');
    if (!wrapper) return;

    const tab = wrapper.querySelector('[data-tab="medidas"]');
    const panel = wrapper.querySelector('[data-panel="medidas"]');
    const mount = wrapper.querySelector('[data-ms-size-guide-mount]');
    const ready = source && source.dataset.msSizeGuideReady === 'true';

    if (!ready) {
      if (tab) tab.classList.add('ms-size-unavailable');
      if (panel) panel.classList.add('ms-size-unavailable');
      const header = wrapper.querySelector('.ms-info-tabs-header');
      if (header) header.style.gridTemplateColumns = 'repeat(3, 1fr)';
      return;
    }

    if (mount && !mount.dataset.msSizeMounted) {
      mount.innerHTML = source.innerHTML;
      mount.dataset.msSizeMounted = 'true';
    }

    replaceProductHoodieSizeDiagram(mount);

    let button = document.querySelector('.ms-size-guide-floating');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'ms-size-guide-floating';
      button.setAttribute('aria-label', 'Abrir guía de tallas');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h18v10H3z"></path><path d="M7 7v4M11 7v2M15 7v4M19 7v2"></path></svg><span>Guía de tallas</span>';
      document.body.appendChild(button);
    }

    if (button.dataset.msSizeBound !== 'true') {
      button.dataset.msSizeBound = 'true';
      button.addEventListener('click', () => {
        const sizeTab = wrapper.querySelector('[data-tab="medidas"]');
        if (sizeTab) sizeTab.click();
        const y = wrapper.getBoundingClientRect().top + window.scrollY - 82;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    }
  }

  function initRelatedCarousels(scope = document) {
    (scope || document).querySelectorAll('[data-ms-related-shell]').forEach((shell) => {
      const track = shell.querySelector('[data-ms-related-carousel]');
      const prev = shell.querySelector('[data-ms-related-prev]');
      const next = shell.querySelector('[data-ms-related-next]');
      if (!track) return;

      function cardStep() {
        const card = track.querySelector('.grid__item');
        if (!card) return Math.max(280, track.clientWidth * .75);
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        const hasOverflow = track.scrollWidth > track.clientWidth + 4;
        if (prev) prev.hidden = !hasOverflow;
        if (next) next.hidden = !hasOverflow;
      }

      if (shell.dataset.msCarouselReady !== 'true') {
        shell.dataset.msCarouselReady = 'true';

        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
        track.addEventListener('scroll', updateArrows, { passive: true });

        let down = false;
        let startX = 0;
        let startScroll = 0;
        let dragged = false;
        let activePointerId = null;
        let suppressClickUntil = 0;
        const dragThreshold = 7;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch' || event.button !== 0) return;
          down = true;
          dragged = false;
          activePointerId = event.pointerId;
          startX = event.clientX;
          startScroll = track.scrollLeft;
        });

        track.addEventListener('pointermove', (event) => {
          if (!down || event.pointerId !== activePointerId) return;
          const dx = event.clientX - startX;

          if (!dragged && Math.abs(dx) > dragThreshold) {
            dragged = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(event.pointerId); } catch (e) {}
          }

          if (!dragged) return;
          event.preventDefault();
          track.scrollLeft = startScroll - dx;
        });

        const stop = (event) => {
          if (!down || (activePointerId !== null && event.pointerId !== activePointerId)) return;
          const wasDragged = dragged;
          down = false;
          dragged = false;
          activePointerId = null;
          track.classList.remove('is-dragging');

          if (wasDragged) {
            suppressClickUntil = performance.now() + 250;
            try { track.releasePointerCapture(event.pointerId); } catch (e) {}
          }
          updateArrows();
        };

        track.addEventListener('pointerup', stop);
        track.addEventListener('pointercancel', stop);
        track.addEventListener('pointerleave', () => {
          if (down && !dragged) {
            down = false;
            activePointerId = null;
          }
        });

        track.addEventListener('click', (event) => {
          if (performance.now() > suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);
      }

      requestAnimationFrame(updateArrows);
      window.setTimeout(updateArrows, 120);
    });
  }

  function init() {
    applyMode(currentMode(), false, false);
    bindButtons();
    initNativeSizeGuide();
    initRelatedCarousels(document);

    const msRelatedObserver = new MutationObserver((mutations) => {
      let shouldCheck = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length) { shouldCheck = true; break; }
      }
      if (shouldCheck) initRelatedCarousels(document);
    });
    if (document.body) msRelatedObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', () => {
      bindButtons();
      setButtonState(currentMode());
      initNativeSizeGuide();
      initRelatedCarousels(document);
    });
  }

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY && (event.newValue === 'dark' || event.newValue === 'light')) {
      applyMode(event.newValue, false, true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
